// React imports
import { useMemo } from 'react';

// Material UI imports
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Alert from '@mui/material/Alert';
import { useTheme } from '@mui/material/styles';

// Local imports
import AccountsDetail from '../accounts/AccountsDetail';

let pos = 0;
let posOrg = null;

function AccountPane(props) {
    const { opportunity, me, organization, accounts } = props;
    const theme = useTheme();

    const account = useMemo(() => accounts?.find(a => a.id === opportunity?.account?.id), [accounts, opportunity?.account?.id]);

    if (!opportunity?.account?.id) {
        return (
            <Box sx={{ width: '100%', background: theme.palette.background.default, pb: 3, overflowY: 'auto', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <Box sx={{ width: '100%', background: 'transparent', padding: '6px 24px', mb: 3, borderBottom: '1px solid rgba(59, 130, 246, 0.3)', boxShadow: 'none' }}>
                    <Typography variant='body1' sx={{ fontSize: '12px', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.05em', color: '#334155' }}>
                        Account
                    </Typography>
                </Box>
                <Alert severity='warning' fullWidth variant='standard' sx={{ width: 'calc(100% - 48px)', mb: 4 }}>
                    Please select an account first.
                </Alert>
            </Box>
        );
    }

    return (
        <Box 
            sx={{ width: '100%', height: '100%', overflowY: 'auto', scrollTop: pos }}  
            onScroll={(e) => { 
                pos = e.target.scrollTop; 
                posOrg = account.id;
            }}
            ref={(r) => { setTimeout(() => { if (r && posOrg === account.id) r.scrollTop = pos; }, 100); }}
        >
            <Box sx={{ width: '100%', background: 'transparent', padding: '6px 24px', mb: 3, borderBottom: '1px solid rgba(59, 130, 246, 0.3)', boxShadow: 'none' }}>
                <Typography variant='body1' sx={{ fontSize: '12px', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.05em', color: '#334155' }}>
                    Account {account?.name ? ` - ${account.name}` : ''}
                </Typography>
            </Box>
            <AccountsDetail {...props} me={me} noHeader={true} organization={organization} org={organization /*backward compatibility*/} accountId={props.opportunity?.account?.id} editable={false} />
        </Box>
    );
}

export default AccountPane;